import React , {Component} from 'react';
import {Link} from "react-router-dom";
import backIcon from './../assets/images/icons/back-2.svg';
import headsetIcon from './../assets/images/icons/headset.svg';
import mapIcon from './../assets/images/icons/map.svg';
import timerIcon from './../assets/images/icons/timer-2.svg';
import descriptionIcon from './../assets/images/icons/description-2.svg';
import shoppingBagIcon from './../assets/images/icons/shopping-bag-2.svg';
import bankCardIcon from './../assets/images/icons/bank-card.svg';
import * as axios from "axios/index";
import * as vars from './Vars';
import NumberFormat from 'react-number-format';
import Loader from './loader/OrderShowLoader';

class OrderShow extends Component{

    constructor(props){

        super(props)
        this.state = {
            order : [] ,
            requestLoading : true ,
        }
    }

    componentDidMount(){
        const { params } = this.props.match;
        let data = new FormData()
        data.append('api_token' , localStorage.getItem("api_token") )
        axios.post(vars.Url +'api/v1/order/' + params.order , data , {
            params : {
            }

        } )
        .then(response => {
            let data = response.data.data
            // console.log(data)
            this.setState({
                requestLoading : false ,
                order : data.orderDetails ,
            })
        })
        .catch(error => {
            // console.log(error)
        })


    }

    render(){
        const {order} = this.state
        return(

            <div id="main-custom-1" className="text-decoration-none">

                {
                    this.state.requestLoading === true ?
                    (
                        <Loader />
                    ):
                    (
                        <div id="main-custom-1" className="text-decoration-none">
                            <header id="header-4">
                                <div className="container p-0">
                                    <div className="row no-gutters justify-content-center">
                                        <div className="col-lg-6">
                                            <div className="items-container">
                                                <div className="row no-gutters justify-content-between">
                                                    <div className="col-auto">
                                                        <Link to="/order">
                                                            <span>
                                                                <img src={backIcon} alt="back" className="item-icon" />
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="row no-gutters justify-content-center">
                                                    <div className="col-auto">
                                                        <div className="img-container">
                                                            <img src={order.trackingIcon} alt="status" className="item-icon"/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row no-gutters justify-content-center mt-5">
                                                    <div className="title">
                                                        {order.trackingTitle}
                                                    </div>
                                                </div>
                                                <div className="row no-gutters justify-content-center mt-2">
                                                    <div className="sub-title">
                                                        {order.trackingDescription}
                                                        {
                                                            order.status === "USER-CANCELED" || order.status === "ADMIN-CANCELED" || order.status === "PAY-CANCELED" ?
                                                                (order.reason) : (``)
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>

                            <div className="container p-0 mt-5">
                                <div className="row no-gutters justify-content-center mb-4">
                                    <div className="col-lg-6">
                                        <div className="items-container items-container-custom-1">
                                            <div className="title-custom-1">
                                                جزئیات سفارش
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row no-gutters justify-content-center mb-4">
                                    <div className="col-lg-6">
                                        <div className="items-container items-container-custom-1">

                                            <div className="row no-gutters justify-content-between align-items-center">
                                                <div className="col-auto">

                                                    <div className="details-custom-3">
                                                        <div className="title ml-2">
                                                            زمان ثبت سفارش:
                                                        </div>
                                                        <div className="value">
                                                            { order.createdDate }
                                                        </div>
                                                    </div>
                                                    <div className="details-custom-3 mt-2">
                                                        <div className="title  ml-2">
                                                            کد سفارش:
                                                        </div>
                                                        <div className="value">
                                                            { order.orderNumber }
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-auto text-center">
                                                    <div className="content-custom-3">
                                                        مشکلی وجود دارد؟
                                                    </div>
                                                    <div className="mt-2">
                                                        <a href={"tel:" + (localStorage.getItem("branchPhone"))} className="btn btn-custom-6 pt-2 pb-2">
                                                            <img src={headsetIcon} alt="headset" className="pl-2"/>
                                                            تماس با پشتیبانی
                                                        </a>
                                                    </div>

                                                </div>
                                            </div>


                                            <div className="row no-gutters mt-5">
                                                <div className="col">


                                                    <div className="bg-custom-1 mb-3">

                                                        <div className="details-custom-1">
                                                            <div className="row no-gutters">
                                                                <div className="col-auto pl-3">
                                                                    <img src={timerIcon} alt="timer" className="item-icon"/>
                                                                </div>
                                                                <div className="col">
                                                                    <div className="title">
                                                                        زمان تحویل
                                                                    </div>
                                                                    <div className="value">
                                                                        {order.deliveryDescription}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>


                                                    <div className="details-custom-1 mb-3">
                                                        <div className="row no-gutters">
                                                            <div className="col-auto pl-3">
                                                                <img src={mapIcon} alt="map" className="item-icon"/>
                                                            </div>
                                                            <div className="col">
                                                                <div className="title">
                                                                    ارسال به
                                                                    <span className="sub-title">
                                                            «
                                                                        { order.addressTitle }
                                                                        »
                                                        </span>
                                                                </div>
                                                                <div className="value">
                                                                    {order.address}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="details-custom-1 mb-3">
                                                        <div className="row no-gutters">
                                                            <div className="col-auto pl-3">
                                                                <img src={descriptionIcon} alt="map" className="item-icon"/>
                                                            </div>
                                                            <div className="col">
                                                                <div className="title">
                                                                    توضیح سفارش
                                                                </div>
                                                                <div className="value">
                                                                    {order.description}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="details-custom-1 mb-3">
                                                        <div className="row no-gutters">
                                                            <div className="col-auto pl-3">
                                                                <img src={shoppingBagIcon} alt="map" className="item-icon"/>
                                                            </div>
                                                            <div className="col">
                                                                <div className="title">
                                                                    کالاهای انتخابی
                                                                </div>
                                                                <div className="value">
                                                                    {order.products.map((product , index) =>
                                                                            <div className="details-custom-3 mb-1" key={index}>
                                                                                <div className="title ml-3">
                                                                                    {product.title}
                                                                                    <span className="mr-1">
                                                                        ({product.count})
                                                                    </span>
                                                                                </div>
                                                                                <div className="value">
                                                                                    <NumberFormat value={ product.count * product.price } displayType={'text'} thousandSeparator={true} className="pl-2" />
                                                                                    تومان
                                                                                </div>
                                                                            </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>



                                                    <div className="details-custom-1 mb-3">
                                                        <div className="row no-gutters">
                                                            <div className="col-auto pl-3">
                                                                <img src={bankCardIcon} alt="map" className="item-icon"/>
                                                            </div>
                                                            <div className="col">
                                                                <div className="title">
                                                                    {order.payType === "IN_PLACE" ? `پرداخت در محل` : `پرداخت آنلاین`}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <footer id="footer-4" className="mt-5">
                                                        <div className="row no-gutters align-items-center justify-content-between">
                                                            <div className="col-auto">
                                                                <div className="payable-price">
                                                                    <div className="title">
                                                                        مبلغ قابل پرداخت
                                                                    </div>
                                                                    <div className="value">
                                                                        <NumberFormat value={ order.payablePrice } displayType={'text'} thousandSeparator={true} className=" pl-2" />
                                                                        <span className="currency">
                                                                تومان
                                                            </span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-auto">
                                                                <div className="row  no-gutters">
                                                                    <div className="col-auto pl-3">
                                                                        <div className="content">
                                                                            پیک
                                                                        </div>
                                                                        <div className="content color-danger">
                                                                            جمع تخفیف
                                                                        </div>
                                                                        <div className="content">
                                                                            اعتبار
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        <div className="content">
                                                                            <NumberFormat value={ order.deliveryPrice } displayType={'text'} thousandSeparator={true} className=" pl-2" />
                                                                            تومان
                                                                        </div>
                                                                        <div className="content  color-danger">
                                                                            <NumberFormat value={ order.discountPrice } displayType={'text'} thousandSeparator={true} className=" pl-2" />
                                                                            تومان
                                                                        </div>
                                                                        <div className="content">
                                                                            <NumberFormat value={ order.walletUsed } displayType={'text'} thousandSeparator={true} className=" pl-2" />
                                                                            تومان
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </footer>


                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                </div>






                            </div>
                        </div>



                    )
                }


            </div>
        )
    }
}

export default OrderShow;